module.exports = __webpack_public_path__ + "img/no-tag2.8372a4df.png";